/** @jsxImportSource @emotion/react */
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { CommonEmail } from '../CommonEmail'

type Props = {
  platform: Platform
}

export const PauseUnpauseMembership = ({ platform }: Props) => (
  <CommonEmail
    type={EmailTemplateTypeEnum.PauseUnpauseMembership}
    platformId={platform.id}
    withDisableForMember
    withDisableForAdmin
    disableForMemberLabel="Check this to disable the email sent to a member when they pause or unpause their membership."
    disableForAdminLabel="Check this to disable the email sent to the administrator when a member pauses or unpauses their membership."
    previewData={{
      username: 'User',
      user_email: 'user@example.com',
      platform_name: platform.title,
      action_status: 'Paused',
    }}
  />
)
